<template>
    <div class="container pt-2">
        <PageTitle main="Serviços" sub="Cadastrar, alterar ou deletar Serviços" />
        <b-form>
            <input id="tipoServico-id" type="hidden" v-model="tipoServico.id" />
            <div class="row">
                <div class="col-md-3">
                    <b-form-group label="Categoria:" label-for="tipoServico-categoria">
                        <b-form-select id="tipoServico-categoria" :options="categorias"
                            v-model="tipoServico.categoria_id"
                            placeholder="Informe categoria."
                            :class="{ 'inputError': $v.tipoServico.categoria_id.$error }"
                            @keydown.tab="$v.tipoServico.categoria_id.$touch"
                            @change="loadSubcategorias"/>
                        <span class="error" v-if="!$v.tipoServico.categoria_id.required && $v.tipoServico.categoria_id.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-3">
                    <b-form-group label="Subcategoria:" label-for="tipoServico-subcategoria">
                        <b-form-select id="tipoServico-subcategoria" :options="subcategorias"
                            v-model="tipoServico.id_subcategoria"
                            placeholder="Informe subcategoria."
                            :class="{ 'inputError': $v.tipoServico.id_subcategoria.$error }"
                            @keydown.tab="$v.tipoServico.id_subcategoria.$touch"/>
                        <span class="error" v-if="!$v.tipoServico.id_subcategoria.required && $v.tipoServico.id_subcategoria.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
                <div class="col-md-3">
                    <b-form-group label="Valor do Serviço:" label-for="tipoServico-valor_receber">
                        <money 
                        v-model="tipoServico.valor_receber" 
                        v-bind="money" 
                        id="tipoServico-valor_receber" 
                        class="form-control" 
                        :class="{ 'inputError': $v.tipoServico.valor_receber.$error }"
                        @keydown.tab="$v.tipoServico.valor_receber.$touch">
                        </money>
                        <span class="error" v-if="!$v.tipoServico.valor_receber.required && $v.tipoServico.valor_receber.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.tipoServico.valor_receber.minLength && $v.tipoServico.valor_receber.$error">Precisa ter no mínimo 2 letras!</span>
                    </b-form-group>
                </div>
                <div class="col-md-3">
                    <b-form-group label="Valor do Repasse:" label-for="tipoServico-valor_pagar">
                        <money 
                        v-model="tipoServico.valor_pagar" 
                        v-bind="money" 
                        id="tipoServico-valor_pagar" 
                        class="form-control" 
                        :class="{ 'inputError': $v.tipoServico.valor_pagar.$error }"
                        @keydown.tab="$v.tipoServico.valor_pagar.$touch">
                        </money>
                        <span class="error" v-if="!$v.tipoServico.valor_pagar.required && $v.tipoServico.valor_pagar.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.tipoServico.valor_pagar.minLength && $v.tipoServico.valor_pagar.$error">Precisa ter no mínimo 2 letras!</span>
                    </b-form-group>
                </div>
            </div>
            <div class="row">
                <div class="col-md-9">
                    <b-form-group label="Titulo:" label-for="tipoServico-titulo">
                        <b-form-input id="tipoServico-titulo" type="text"
                            v-model="tipoServico.titulo"
                            :class="{ 'inputError': $v.tipoServico.titulo.$error }"
                            @keydown.tab="$v.tipoServico.titulo.$touch"/>
                        <span class="error" v-if="!$v.tipoServico.titulo.required && $v.tipoServico.titulo.$error">Campo Obrigatório!</span>
                        <span class="error" v-if="!$v.tipoServico.titulo.minLength && $v.tipoServico.titulo.$error">Precisa ter no mínimo 2 letras!</span>
                    </b-form-group>
                </div>
                <div class="col-md-3">
                    <b-form-group label="Prazo:" label-for="tipoServico-prazo">
                        <b-form-input id="tipoServico-prazo" type="text"
                            v-model="tipoServico.prazo"
                            :class="{ 'inputError': $v.tipoServico.prazo.$error }"
                            @keydown.tab="$v.tipoServico.prazo.$touch"/>
                        <span class="error" v-if="!$v.tipoServico.prazo.required && $v.tipoServico.prazo.$error">Campo Obrigatório!</span>
                    </b-form-group>
                </div>
            </div>
            <div class="row mb-3">
                <div class="col-md-12">
                    <label for="tipoServico-descricao">Descrição do Serviço:</label>
                    <b-form-textarea id="tipoServico-descricao" placeholder="Escreva aqui..."
                        rows="3" v-model="tipoServico.descricao"
                        :class="{ 'inputError': $v.tipoServico.descricao.$error }"
                        @keydown.tab="$v.tipoServico.descricao.$touch">
                    </b-form-textarea>
                    <span class="error" v-if="!$v.tipoServico.descricao.required && $v.tipoServico.descricao.$error">Campo Obrigatório!</span>
                    <span class="error" v-if="!$v.tipoServico.descricao.minLength && $v.tipoServico.descricao.$error">Precisa ter no mínimo 3 caracteres!</span>
                </div>
            </div>
            <b-button variant="outline-success" class="btn-custom" @click="save">Salvar</b-button>
            <b-button variant="outline-danger" class="ml-2 btn-custom" @click="reset">Cancelar</b-button>
        </b-form>
        <hr>
        <div :style="{ overflow: overflowValue, width: larguraTela + 'px' }" v-if="larguraTela<721">
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-tipoServicos" 
                class="text-center table table-sm" 
                :items="tipoServicos" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 text-white" @click="loadTipoServico(data.item)">
                        <font-awesome-icon :icon="['fa', 'edit']"/>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1" @click="remove(data.item)">
                        <font-awesome-icon :icon="['fa', 'trash']"/>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-tipoServicos"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
        <div v-else>
            <div class="row mb-3">
                <div class="col-md-7">
                </div>
                <div class="col-md-5">
                    <b-input-group size="sm">
                        <b-form-input
                        v-model="filtro"
                        type="search"
                        id="filterInput"
                        placeholder="Pesquisar..."
                        ></b-form-input>
                        <b-input-group-append>
                        <b-button :disabled="!filtro" @click="filtro = ''">Limpar</b-button>
                        </b-input-group-append>
                    </b-input-group>
                </div>
            </div>
            <b-table 
                hover 
                striped 
                id="table-tipoServicos" 
                class="text-center table table-sm" 
                :items="tipoServicos" 
                :fields="fields" 
                per-page="3"
                :current-page="currentPage"
                :filter="filtro"
                :filterIncludedFields="filtrando"
                @filtered="onFiltered">
                <template v-slot:cell(actions)="data">
                    <b-button variant="warning" class="mr-2 btn-sm mb-1 text-white" @click="loadTipoServico(data.item)">
                        <font-awesome-icon :icon="['fa', 'edit']"/>
                    </b-button>
                    <b-button variant="danger" class="mr-2 btn-sm mb-1" @click="remove(data.item)">
                        <font-awesome-icon :icon="['fa', 'trash']"/>
                    </b-button>
                </template>
            </b-table>
            <div class="row" v-if="exibeRodape">
                <div class="col-md-12 text-center mb-3">
                    <span class="text-custom"><i>Não há nenhum dado disponível!</i></span>
                </div>
            </div>
            <div>
                <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                per-page="3"
                aria-controls="table-tipoServicos"
                first-number
                last-number
                align="center"
                ></b-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PageTitle from '@/components/template/PageTitle'
import { mask } from 'vue-the-mask'
import { required, minLength } from 'vuelidate/lib/validators'
import { VMoney } from 'v-money'
import { VueEasyJwt } from 'vue-easy-jwt'

export default {
    name: 'tipoServicos',
    components: { PageTitle },
    directives: { mask, money: VMoney },
    data: function() {
        return {
            jwt: new VueEasyJwt(),
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            tipoServico: {},
            tipoServicos: [],
            categoria: {},
            categorias: [],
            subcategoria: {},
            subcategorias: [],
            exibeRodape: true,
            currentPage: 1,
            filtro: null,
            filtrando: [],
            totalRows: 1,
            fields: [
                { key: 'titulo', label: 'Serviço', sortable: true },
                { key: 'categoria_titulo', label: 'Categoria', sortable: true },
                { key: 'subcategoria_titulo', label: 'Subcategoria', sortable: true },
                { key: 'valor_receber', label: 'Valor', sortable: true, formatter: 'defineValor' },
                { key: 'valor_pagar', label: 'Repasse', sortable: true, formatter: 'defineValor' },
                { key: 'prazo', label: 'Prazo', sortable: true, formatter: 'definePrazo' },
                { key: 'actions', label: 'Ações', thStyle: { width: '20%' } }
            ],
            larguraTela: 0,
            overflowValue: 'auto'
        }
    },
    validations: {
        tipoServico: {
            titulo: {
                required,
                minLength: minLength(2)
            },
            descricao: {
                required,
                minLength: minLength(2)
            },
            valor_pagar: {
                required,
                minLength: minLength(2)
            },
            valor_receber: {
                required,
                minLength: minLength(2)
            },
            categoria_id: {
                required
            },
            id_subcategoria: {
                required
            },
            prazo: {
                required
            }
        }
    },
    computed: {
        rows() {
            return this.tipoServicos.length
        }
    },
    methods: {
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length
            this.currentPage = 1
        },
        definePrazo(value) {
            const texto = value + ' dias'
            return texto
        },
        defineValor(value) {
            const prefix = 'R$ '
            // const flutuante = value.indexOf('.')
            // if(flutuante === '-1') {
            //     const reais = value
            //     const centavos = '00'
            // } else {
                const arr = value.split('.')
                const reais = arr[0]
                const centavos = arr[1] === undefined ? '00' : arr[1]
            // }
            return `${prefix}${reais},${centavos}`
        },
        loadCategorias() {
            const url = `${baseApiUrl}/backend/SELECT/categorias.php`
            axios.get(url).then(res => {
                this.categorias = res.data.map(categoria => {
                    return { ...categoria, value: categoria.id, text: categoria.titulo }
                })
            }).catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
            })
        },
        loadSubcategorias() {
            const id = this.tipoServico.categoria_id
            // const id = document.getElementById("tipoServico-categoria").value
            const url = `${baseApiUrl}/backend/GENERAL/subcategoriasByCategoria.php?categoria=${id}`
            axios.get(url).then(res => {
                this.subcategorias = res.data.map(subcategoria => {
                    return { ...subcategoria, value: subcategoria.id, text: subcategoria.titulo }
                })
            }).catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
            })
        },
        loadTipoServicos() {
            const url = `${baseApiUrl}/backend/SELECT/tipoServico.php`
            axios.get(url).then(res => {
                this.tipoServicos = res.data
                this.exibeRodape = false
            }).catch(
                (e) => {
                this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                this.exibeRodape = true
            })
        },
        reset() {
            this.tipoServico = {}
            this.loadTipoServicos()
            this.$v.tipoServico.$reset()
        },
        save() {
            this.$v.tipoServico.$touch()
            if(!this.$v.tipoServico.$error){
                const method = this.tipoServico.id ? 'put' : 'post'
                const id = this.tipoServico.id ? `?id=${this.tipoServico.id}` : ''
                if(method==='post'){
                    axios['post'](`${baseApiUrl}/backend/INSERT/tipoServico.php${id}`, this.tipoServico)
                        .then(() => {
                            this.$toasted.global.defaultSuccess({ message : 'Serviço inserido com sucesso!' })
                            this.reset()
                        })
                        .catch(
                            (e) => {
                            this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                        }
                        )
                } else {
                    axios['put'](`${baseApiUrl}/backend/UPDATE/tipoServico.php${id}`, this.tipoServico)
                        .then(() => {
                            this.$toasted.global.defaultSuccess({ message : 'Serviço alterado com sucesso!' })
                            this.reset()
                        })
                        .catch(
                            (e) => {
                            this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                        }
                        )
                }
            } else {
                this.$toasted.global.defaultError({ message : 'Verifique os campos!' })
            }
        },
        remove(tipoServico) {
            const sure = confirm("Deseja realmente excluir o Serviço?")
            if(sure === true){
                const url = `${baseApiUrl}/backend/DELETE/tipoServico.php`
                axios.delete(url, { data: tipoServico })
                    .then(() => {
                        this.$toasted.global.defaultSuccess({ message : 'Serviço excluído com sucesso!' })
                        this.reset()
                    })
                    .catch(
                        (e) => {
                        this.$toasted.global.defaultError({ message : e.response.data['dados'] })
                    }
                    )
            }
        },
        loadTipoServico(tipoServico) {
            this.tipoServico = { ...tipoServico }
            this.loadSubcategorias()
        },
        validaLogin() {
            const local = localStorage.getItem('__SYSTEM_USER')
            const decodedToken = this.jwt.decodeToken(local)
            if (local === null) {
                this.$router.push({ path: '/login' })
            } else {
                this.nivel = decodedToken['data'].nivel
                this.quemRecebeu = decodedToken['data'].id
            }
        }
    },
    mounted() {
        this.validaLogin()
        if(this.nivel !== 'admin') {
            this.$router.push('/')
        }
        this.loadCategorias()
        this.loadTipoServicos()
        this.larguraTela = screen.width - (screen.width * 0.08)
        this.totalRows = this.tipoServicos.length
    }
}
</script>

<style>
.table {
    font-size: 0.9rem;
}

#tipoServico-titulo, #tipoServico-categoria, #tipoServico-subcategoria, #tipoServico-descricao, 
#tipoServico-prazo, #tipoServico-valor_receber, #tipoServico-valor_pagar {
    /* border: 0; */
    outline: 0;
    border-radius: 10px;
    /* border-bottom: 1px solid #AAA; */
    background-color: rgba(255,255,255,0.4);
    box-shadow: 1px 1px 2px 0px rgba(107,107,107,0.45);
}

.error {
    color: #f57f6c;
    font-size: 0.6rem;
    padding-left: 10px;
}

.inputError {
    color: #f57f6c;
    border: 1px solid #f57f6c !important;
}

.text-custom {
    font-size: 0.8rem;
}

.btn-custom {
    border-radius: 10px;
    box-shadow: 1px 1px 2px 0px rgba(107,107,107,0.45);
    background-color: rgba(255,255,255,0.4);
}
</style>